import React from "react";

import { DeleteIcon, EditIcon, IconButton, ToggleSwitch } from "shared/ui";
import { localizedText } from "shared/lib/localizedMap";

import { BadgePill } from "features/MenuItemBadges/components/BadgePill";
import { BADGE_PLACEMENT_OPTIONS } from "features/MenuItemBadges/constants";
import { useMenuItemBadgesContext } from "features/MenuItemBadges/context";

import { Actions, Caption, List, PillWrap, Row } from "./styles";

export const BadgesList = () => {
    const state = useMenuItemBadgesContext();

    return (
        <List>
            {state.badges.map((badge) => {
                const placement = BADGE_PLACEMENT_OPTIONS.find(
                    (option) => option.value === badge.placement
                );

                return (
                    <Row key={badge.id}>
                        <PillWrap>
                            <BadgePill
                                title={localizedText(badge.title, state.locale)}
                                fill={badge.fill}
                                textColor={badge.textColor}
                            />
                        </PillWrap>
                        <Caption>{placement ? placement.label : badge.placement}</Caption>
                        <Actions>
                            <ToggleSwitch
                                checked={badge.isEnabled}
                                onChange={() => state.toggleBadgeEnabled(badge)}
                                ariaLabel="Показывать бейдж в меню"
                                disabled={state.saving}
                            />
                            <IconButton
                                label="Изменить бейдж"
                                size="small"
                                onClick={() => state.openEditDialog(badge)}
                            >
                                <EditIcon />
                            </IconButton>
                            <IconButton
                                label="Удалить бейдж"
                                size="small"
                                tone="danger"
                                onClick={() => state.openDeleteDialog(badge)}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </Actions>
                    </Row>
                );
            })}
        </List>
    );
};
